import React from 'react';
import IconLogoLink from './IconLogoLink';
import ZitoneoLink from './ZitoneoLink';

export interface HeaderNavigationProps {
    isLoading: boolean;
    hasUnsavedChanges: boolean;
    onSave: () => Promise<void>;
    onBackToList: () => void;
}

interface HeaderBrandProps extends HeaderNavigationProps {
    onBackToHome: () => void;
}

const HeaderBrand = ({
    isLoading,
    hasUnsavedChanges,
    onSave,
    onBackToList,
    onBackToHome,
}: HeaderBrandProps) => {
    const linkProps = { isLoading, hasUnsavedChanges, onSave };

    return (
        <div className='zitoneo-header__brand'>
            <div className='zitoneo-header__logo'>
                <IconLogoLink {...linkProps} onClick={onBackToHome} />
            </div>
            <div className='zitoneo-header__brand-title'>
                <ZitoneoLink {...linkProps} onClick={onBackToList} />
            </div>
        </div>
    );
};

export default HeaderBrand;
